// Func = limiting Scope for this file
var lastScrollTop = 0;
//resize sizes
var w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;
resizeWindow();


(function(){

	if(document.getElementById('primary-nav')){
		let allLinks = document.getElementById('primary-nav').getElementsByTagName('a')
		for(let i =0; i < allLinks.length; i++){
			allLinks[i].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1]
				animateTo(currentTarget);
				for(let j= 0; j < allLinks.length; j++){
					if(this !== allLinks[j]){
						allLinks[j].classList.remove('active')
					} else {
						allLinks[j].classList.add('active')
					}
				}
				if(document.getElementById('burgerMenu')){
					document.getElementById('burgerMenu').classList.remove('open')
					document.getElementById('primary-nav').classList.remove('open')
				}
			})
		}
	}

	//btn
	if(document.getElementsByClassName('btn').length > 0){
		let allBtn = document.getElementsByClassName('btn');
		for( let i = 0;i < allBtn.length; i++){
			let innerText = allBtn[i].innerHTML;
			allBtn[i].innerHTML = '<span>' + innerText + '</span>';
		}
	}

	//menu burger
	if(document.getElementById('burgerMenu')){
		document.getElementById('burgerMenu').addEventListener('click', function(){
			if(!document.getElementById('burgerMenu').classList.contains('open')){
				document.getElementById('burgerMenu').classList.add('open')
				document.getElementById('primary-nav').classList.add('open')
			} else {
				document.getElementById('burgerMenu').classList.remove('open')
				document.getElementById('primary-nav').classList.remove('open')
			}
		})
	}

	//amenities
	if(document.getElementById('amenitiesBlock')){
		if(document.getElementById('amenitiesContainer')){
			document.getElementById('amenitiesBlock').appendChild(document.getElementById('amenitiesContainer'))
		}
	}

	window.onload = function() {


		//footer buttons in mobile
		if(windowWidth < 600){
			if(document.getElementById('footerButtons')){
				let buttonsContainer = document.getElementById('footerButtons');
				let buttonCall = document.getElementById('footerCall');
				let bookCta = document.getElementById('bookCta');
				if(document.getElementById('burgerMenu')){
					let burgerMenu = document.getElementById('burgerMenu');
					buttonsContainer.insertBefore(burgerMenu,buttonCall);
				}
				buttonsContainer.insertBefore(bookCta,buttonCall);
			}
		}

		resizeWindow();
		window.addEventListener('resize', function(){
			resizeWindow();
		});

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
function resizeWindow(){
	//calculate a new window size
	windowWidth = w.innerWidth||e.clientWidth||g.clientWidth;
	windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;


	
}